<template>
  <div class="court-record" v-show="status">
    <div class="content"  v-show="userType != 3">
      <div class="title">
        湛江仲裁委员会 开庭笔录<img v-if="userType !== 3" @click="$emit('handle', { type: 2, event: -1 })" class="click" src="../assets/icon_close_black.png" alt="">
      </div>
      <p class="time">上次自动同步时间：{{ time }}  <span class="click" @click="_refresh">刷新</span> </p>
      <div class="info" v-html='content'>
      </div>
    </div>
    <div class="content edit"  v-show="userType === 3">
      <div class="title">
        湛江仲裁委员会 编辑开庭笔录 <img @click="$emit('handle', { type: 2, event: -1 })" class="click" src="../assets/icon_close_black.png" alt=""><button class="click" @click="open">全屏</button>
      </div>
      <p class="time">上次自动同步时间：{{ time }}</p>
      <div class="info" ref="editor">
      </div>
      <div class="btn"><button class="click" @click="_submit">保存</button></div>
    </div>
  </div>
</template>

<script>
import { meCourtRecord, refreshRecord, aiText } from '@/service/getData'
import E from 'wangeditor'
export default {
  props: {
    id: {
      default: -1
    },
    userType: {
      default: -1
    },
    status: {
      default: false
    }
  },
  data () {
    return {
      content: '',
      time: '',
      editContent: '',
      editor: null,
      iv: null,
      text: ''
    }
  },
  methods: {
    /**
     * 初始化编辑器
     */
    initEdit () {
      this.editor = new E(this.$refs.editor)
      this.editor.customConfig.menus = [
        'bold',
        'head',
        'fontSize',
        'fontName',
        'italic',
        'underline',
        'strikeThrough',
        'foreColor',
        'backColor',
        'list',
        'justify',
        'undo',
        'redo'
      ]
      this.editor.customConfig.pasteFilterStyle = true
      this.editor.customConfig.onchange = (html) => {
        this.editContent = html
      }
      this.editor.create()
      this.editor.txt.html(this.editContent)
    },

    /**
     * 刷新笔录
     */
    async _refresh (edit = true) {
      if (this.userType === 3) {
        var ai = await aiText(this.id)
        if (ai.code === 1) {
          this.content = ai.data.content
        }
      }
      this.time = this.$util.formatDate(new Date().getTime())
      var record = await meCourtRecord(this.id)
      if (record.code === 1) {
        if (this.userType === 3) {
          if (edit) {
            if (this.editor !== null && this.text !== record.data.content) {
              this.editContent = record.data.content
              this.text = record.data.content
              this.editor.txt.html(this.editContent)
            }
          }
        } else {
          this.content = record.data.content
        }
      }
    },

    /**
     * 提交笔录
     */
    async _submit () {
      var res = await refreshRecord({ meetingId: this.id, content: this.editContent })
      if (res.code !== 1) {
        this.$message.error(res.msg)
      } else {
        this.text = this.editContent
        this.$message.success('保存成功')
      }
    },

    open () {
      var routeData = this.$router.resolve({
        path: '/secretary-record',
        query: {
          id: this.id,
          userType: this.userType
        }
      })
      window.open(routeData.href, '_blank')
    }
  },
  watch: {
    status (newStatus, oldStatus) {
      if (newStatus) {
        this._refresh()
        if (this.userType === 3 && this.editor === null) {
          this.initEdit()
        }
        this.iv = setInterval(() => {
          this._refresh(false)
          if (this.userType === 3 && this.text !== this.editContent) {
            this._submit()
          }
        }, 10000)
      } else {
        if (this.iv !== null) {
          clearInterval(this.iv)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.court-record {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include ct;
    background-color: #F0F0F0;
    border-radius: 0.083rem;
    overflow: hidden;
    right: 2.53rem;
    width: 700px;
    padding-bottom: 0.3rem;
    &.edit {
      padding-bottom: 0.1rem;
      width: 770px;
      .info {
        padding: 0;
        height: 5rem;
        box-sizing: border-box;
        .w-e-text-container {
          height: calc(100% - 58px) !important;
        }
        .w-e-toolbar {
          flex-wrap: wrap;
        }
      }
      .btn {
        text-align: center;
        line-height: 0.675rem;
        button {
          line-height: 1;
          background-color: #267CD0;
          color: #fff;
          padding: 0.08rem 0.108rem;
          border-radius: 0.25rem;
          font-size: 0.133rem;
          font-family: PingFang SC;
          font-weight: 500;
        }
      }
    }
    &.r {
      right: 530px;
    }
    .info {
      overflow: auto;
      background-color: #fff;
      margin: 0 0.167rem;
      height: 5.475rem;
      border-radius: 0.083rem;
      padding: 0.15rem;
      font-size: 0.117rem;
      color: #333333;
      white-space: normal;
      word-break: break-all;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background-color: #F5F5F5;
      }
    }
    .time {
      text-align: center;
      font-size: 0.117rem;
      line-height: 0.4rem;
      color: #666666;
      span {
        color: #3D97E6;
      }
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
    }
    .title {
      height: 0.442rem;
      line-height: 0.442rem;
      font-size: 0.15rem;
      font-family:PingFang SC;
      font-weight:bold;
      text-align: center;
      position: relative;
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem)
      }
    }
  }
}
</style>
